import ScoreStart from './ScoreStart.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'scoreStart', ScoreStart);
  },
};
